import { SnkModifier } from 'graphql/models/extended';
import { Account } from 'graphql/models/generated';

export function getAccountFullName(account?: Account | SnkModifier): string {
  if (!account) return '';

  const firstName = (account.profile && account.profile.firstName) || '';
  const lastName = (account.profile && account.profile.lastName) || '';

  return `${firstName} ${lastName}`;
}
